import { logger } from "cayo.ui";
import HttpStatus from "@cayo/shared/api/types/HttpStatus";
import { processErrorResponse } from "@cayo/shared/utils/ajax";

export interface ProfileElement {
  "@odata.context": string;
  elementClass: string;
  name: string;
  value: string;
  createdAt: string;
  updatedAt: string;
}

// TODO: this should come from ui-scheme
const endpoints = {
  me: "/v1.0/me",
  save: "/saveProfileElement",
  get: "/getProfileElement",
  list: "/listProfileElements",
  delete: "/deleteProfileElement",
};

const log = logger.getLogger("UserMeProfileClient");

export class UserMeProfileClient {
  constructor(
    private baseUrl: string = "",
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> } = window as any
  ) {}

  async saveProfileElement(
    // elementClass could be arbitrary
    elementClass: string,
    name: string,
    value: string[]
  ): Promise<ProfileElement | null> {
    try {
      const response = await this.http.fetch(`${this.baseUrl}${endpoints.me}${endpoints.save}`, {
        method: "POST",
        body: JSON.stringify({ elementClass, name, value: JSON.stringify(value) }),
        headers: { "Content-Type": "application/json" },
      });
      if (response.status === HttpStatus.OK) {
        const profile = await response.json();
        return profile ?? null;
      }
      if (response.status !== HttpStatus.NO_CONTENT) {
        await processErrorResponse(response, response.status);
      }
    } catch (e) {
      log.error("saveProfileElement, failed to save profile element", e);
    }
    return null;
  }

  async getProfileElement(elementClass: string, name: string): Promise<ProfileElement | null> {
    try {
      const url =
        `${this.baseUrl}${endpoints.me}${endpoints.get}(elementClass='${encodeURIComponent(elementClass)}',` +
        `name='${encodeURIComponent(name)}')`;
      const response = await this.http.fetch(url, {
        method: "GET",
        headers: { Accept: "application/json" },
      });
      if (response.status === HttpStatus.OK) {
        const profile = await response.json();
        return profile ?? null;
      }
      if (response.status !== HttpStatus.NO_CONTENT) {
        await processErrorResponse(response, response.status);
      }
    } catch (e) {
      log.error("getProfileElement, failed to get profile element", e);
    }
    return null;
  }

  async listProfileElement(elementClass: string): Promise<string | null> {
    try {
      const url = `${this.baseUrl}${endpoints.me}${endpoints.list}(elementClass='${encodeURIComponent(elementClass)}')`;
      const response = await this.http.fetch(url, {
        method: "GET",
        headers: { Accept: "application/json" },
      });
      if (response.status === HttpStatus.OK) {
        const profile = await response.json();
        return profile ?? null;
      }
      if (response.status !== HttpStatus.NO_CONTENT) {
        await processErrorResponse(response, response.status);
      }
    } catch (e) {
      log.error("listProfileElement, failed to list profile element", e);
    }
    return null;
  }

  async deleteProfileElement(elementClass: string, name: string): Promise<void> {
    try {
      const response = await this.http.fetch(`${this.baseUrl}${endpoints.me}${endpoints.delete}`, {
        method: "POST",
        body: JSON.stringify({ elementClass, name }),
        headers: { "Content-Type": "application/json" },
      });
      if (response.status !== HttpStatus.OK && response.status !== HttpStatus.NO_CONTENT) {
        await processErrorResponse(response, response.status);
      }
    } catch (e) {
      log.error("listProfileElement, failed to delete profile element", e);
    }
  }
}
